import React from "react";
import { BsTelephone, BsEnvelope } from "react-icons/bs";
import { TbMapPin } from "react-icons/tb";
import {
  FaFacebookSquare,
  FaYoutubeSquare,
  FaInstagramSquare,
  FaLinkedin,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="w-full py-10 bg-white">
      <div className="max-w-screen-xl mx-auto flex mdl:flex-row gap-8 mb-7 mt-4 border-b-[1px] border-b-[#434343]">
        <div className="w-full h-auto px-4 xl:px-0 flex flex-col xl:gap-6 xl:flex-row">
          <div className="w-full xl:w-1/4">
            <Link to="/sitemap">
              <h3 className="w-full font-titleFont text-[15px] tracking-wide font-semibold uppercase text-primeColor border-b-[1px] py-2 border-b-[#434343]">
                Quick links - EduCare
              </h3>
              <div className="flex flex-col gap-4 py-6 w-full justify-between">
                <p>
                  Educare - Take you English to the next level <br /> Go to
                  Sitemap to view all.
                </p>
                <ul className="flex flex-col gap-0 lg:gap-2">
                  <li className="footerli hover:pl-7 hover:text-primeColor group">
                    <span className="footerlispan group-hover:pl-6 transition-pl"></span>
                    Site Map
                  </li>
                </ul>
              </div>
            </Link>
          </div>
          <div className="w-full xl:w-2/5">
            <h3 className="w-full font-titleFont text-[15px] tracking-wide font-semibold uppercase text-primeColor border-b-[1px] py-2 border-b-[#434343]">
              Our Courses
            </h3>
            <div className="flex flex-col lg:flex-row py-6 w-full justify-between text-[#434343]">
              <div className="w-full lg:w-1/2">
                <ul className="flex flex-col gap-0 lg:gap-2">
                  <Link to="/spokenenglish">
                    <li className="footerli hover:pl-7 hover:text-primeColor group">
                      <span className="footerlispan group-hover:pl-6 transition-pl"></span>
                      Spoken English
                    </li>
                  </Link>
                  <Link to="/academicenglish">
                    <li className="footerli hover:pl-7 hover:text-primeColor group mt-2 lg:mt-0">
                      <span className="footerlispan group-hover:pl-6 transition-pl"></span>
                      Academic English
                    </li>
                  </Link>
                  <Link to="/englishwriting">
                    {" "}
                    <li className="footerli hover:pl-7 hover:text-primeColor group mt-2 lg:mt-0">
                      <span className="footerlispan group-hover:pl-6 transition-pl"></span>
                      English Writing
                    </li>
                  </Link>
                  <Link to="/phonetics">
                    <li className="footerli hover:pl-7 hover:text-primeColor group mt-2 lg:mt-0">
                      <span className="footerlispan group-hover:pl-6 transition-pl"></span>
                      Phonetics
                    </li>
                  </Link>
                </ul>
              </div>
              <div className="w-full lg:w-1/2">
                <ul className="flex flex-col gap-0 lg:gap-2">
                  <Link to="/ielts">
                    <li className="footerli hover:pl-7 hover:text-primeColor group mt-2 lg:mt-0">
                      <span className="footerlispan group-hover:pl-6 transition-pl"></span>
                      IELTS
                    </li>
                  </Link>
                  <Link to="/ieltsmocktest">
                    <li className="footerli hover:pl-7 hover:text-primeColor group mt-2 lg:mt-0">
                      <span className="footerlispan group-hover:pl-6 transition-pl"></span>
                      IELTS Mock Test
                    </li>
                  </Link>
                  <Link to="msoffice">
                    <li className="footerli hover:pl-7 hover:text-primeColor group mt-2 lg:mt-0">
                      <span className="footerlispan group-hover:pl-6 transition-pl"></span>
                      Microsoft Office
                    </li>
                  </Link>
                  <Link to="/careerdevelopment">
                    <li className="footerli hover:pl-7 hover:text-primeColor group mt-2 lg:mt-0">
                      <span className="footerlispan group-hover:pl-6 transition-pl"></span>
                      Career Development
                    </li>
                  </Link>
                </ul>
              </div>
            </div>
          </div>
          <div className="w-full xl:w-1/3">
            <h3 className="w-full font-titleFont text-[15px] tracking-wide font-semibold uppercase text-primeColor border-b-[1px] py-2 border-b-[#434343]">
              Contact Address
            </h3>
            <div className="flex py-6 w-full justify-between text-[#434343]">
              <ul className="flex flex-col gap-4">
                <li className="flex justify-start gap-1 text-[14px] font-bodyFont">
                  <span className="flex items-center">
                    <TbMapPin className="text-lg mr-1" />
                  </span>
                  285/K, Sajid Tower, Joydebpur Bus Stand Road, Gazipur.
                </li>
                <li className="flex justify-start items-center gap-1 text-[14px] font-bodyFont">
                  <span className="flex items-center">
                    <BsTelephone className="text-lg mr-1" />
                  </span>
                  +88 01975598780
                </li>
                <li className="flex justify-start items-center gap-1 text-[14px] font-bodyFont">
                  <span className="flex items-center">
                    <BsEnvelope className="text-lg mr-1" />
                  </span>
                  <a href="mailto:query.educare@gmail.com">
                    query.educare@gmail.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-screen-xl mx-auto flex flex-col xl:flex-row gap-2 justify-between items-center">
        <div>
          <p className="font-bodyFont text-sm">
            © 2022{" "}
            <a
              href="https://reactbd.vercel.app/"
              rel="noreferrer"
              target="_blank"
            >
              {" "}
              <span className="font-semibold hover:text-primeColor transition-hover duration-300 cursor-pointer">
                reactbd.com
              </span>{" "}
            </a>
            All rights reserved.
          </p>
        </div>
        <div>
          <div className="flex w-full justify-center  mdl:justify-start gap-1 mdl:-mt-3 lg:-mt-0">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/educareenglishlearningacademy/"
            >
              <FaFacebookSquare
                size={30}
                className="fill-primeColor hover:fill-[#4267B2] cursor-pointer transform ease-in-out duration-300"
              />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/educare_englishlearningacademy/"
            >
              <FaInstagramSquare
                size={30}
                className="fill-primeColor hover:fill-[#b8278b] cursor-pointer transform ease-in-out duration-300"
              />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https:www.youtube.com/channel/UCcci_0jFRNEVQSBXTgyodZA/"
            >
              <FaYoutubeSquare
                size={30}
                className="fill-primeColor hover:fill-red-600 cursor-pointer transform ease-in-out duration-300"
              />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.linkedin.com/company/educare-english-learning-academy/"
            >
              <FaLinkedin
                size={30}
                className="fill-primeColor hover:fill-[#0e76a8] cursor-pointer transform ease-in-out duration-300"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
